import Button from './_button.js'
import Image from './_image.js'
import Hideable from './_hideable.js'

export default {
  name: 'DownloadBetPdfButton',
  values: {
    button: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
          },
        },
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        src: 'download',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    text: {
      configSet: Hideable,
      configValues: {
        hide: true,
      },
    },
    style: {
      text: {
        paddingLeft: undefined,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
